cockpitApp.directive('languageSwitch', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/language-switch',
    controllerAs: 'languageSwitchCtrl',
    controller: 'languageSwitchController'
  };
});
